export default __webpack_public_path__ + "static/media/WritingGame.9cbde492.wav";